export default __webpack_public_path__ + "static/votes-e040f49e653650bff206a1bee1fe5b34.jpg";